// src/components/ActionModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';

const ActionModal = ({
  isActionModalOpen,
  setIsActionModalOpen,
  handleActionSubmit,    // => handleActionSubmit(requests)
  selectedEquipment,
}) => {
  const [form] = Form.useForm();

  // Состояния для фото под каждое действие
  const [photoFilesTo3, setPhotoFilesTo3] = useState([]);
  const [photoFilesTo2, setPhotoFilesTo2] = useState([]);
  const [photoFilesTo1, setPhotoFilesTo1] = useState([]);
  const [photoFilesSingle, setPhotoFilesSingle] = useState([]); // для обычных (to1 alone, majorRepair, etc.)

  // Какое основное Action выбрано?
  const [currentAction, setCurrentAction] = useState(null);

  // При выборе действия
  const handleActionChange = (value) => {
    setCurrentAction(value);
    // Сбрасываем ручной статус
    form.setFieldValue('manualStatus', undefined);
  };

  // При выборе ручного статуса
  const handleManualStatusChange = () => {
    setCurrentAction(null);
    form.setFieldValue('action', undefined);
  };

  const isDisabled = (freqName) => {
    if (!selectedEquipment) return false;
    return selectedEquipment[freqName] === 'Н/У';
  };

  // Ограничение файлов
  const handleFileChange = (e, setFiles) => {
    let files = Array.from(e.target.files);
    if (files.length > 10) {
      alert('Максимум 10 фото!');
      files = files.slice(0, 10);
    }
    setFiles(files);
  };

  // --------------------------------------------
  // Формируем массив requests при "onFinish"
  // --------------------------------------------
  const onFinish = (values) => {
    // Проверка
    if (values.action && values.manualStatus) {
      alert('Нельзя одновременно выполнять действие и выставлять ручной статус.');
      return;
    }

    const requests = [];
    
    // -- Если user выбрал to3 --
    if (values.action === 'to3') {
      // 1) Действие to3
      requests.push({
        action: 'to3',
        comment: values.commentTo3 || 'Без комментария',
        photoFiles: photoFilesTo3,
      });
      // 2) Действие to2 (только если заполнено)
      if (values.commentTo2) {
        requests.push({
          action: 'to2',
          comment: values.commentTo2,
          photoFiles: photoFilesTo2,
        });
      }
      // 3) Действие to1 (только если заполнено)
      if (values.commentTo1) {
        requests.push({
          action: 'to1',
          comment: values.commentTo1,
          photoFiles: photoFilesTo1,
        });
      }
    }
    // -- Если user выбрал to2 --
    else if (values.action === 'to2') {
      // 1) Действие to2
      requests.push({
        action: 'to2',
        comment: values.commentTo2 || 'Без комментария',
        photoFiles: photoFilesTo2,
      });
      // 2) Действие to1
      if (values.commentTo1) {
        requests.push({
          action: 'to1',
          comment: values.commentTo1,
          photoFiles: photoFilesTo1,
        });
      }
    }
    // -- Если user выбрал to1 / majorRepair / ... --
    else if (values.action) {
      requests.push({
        action: values.action,
        comment: values.commentSingle || 'Без комментария',
        photoFiles: photoFilesSingle,
      });
    }

    // -- Если user выбрал manualStatus --
    if (values.manualStatus) {
      requests.push({
        manualStatus: values.manualStatus,
        comment: values.commentSingle || 'Без комментария',
        photoFiles: photoFilesSingle, // пусть тоже те же файлы
      });
    }

    // Вызываем handleActionSubmit
    handleActionSubmit(requests);

    // Сброс
    form.resetFields();
    setIsActionModalOpen(false);
    resetAllFiles();
  };

  const resetAllFiles = () => {
    setPhotoFilesTo3([]);
    setPhotoFilesTo2([]);
    setPhotoFilesTo1([]);
    setPhotoFilesSingle([]);
  };

  // При отмене
  const onCancel = () => {
    form.resetFields();
    setIsActionModalOpen(false);
    resetAllFiles();
  };

  // -------------------------------------------------------
  // В render: показываем разные поля в зависимости от currentAction
  // -------------------------------------------------------
  return (
    <Modal
      title="Действие инженера"
      open={isActionModalOpen}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        
        <Form.Item
          name="action"
          label="Выберите действие"
          rules={[
            {
              required: !form.getFieldValue('manualStatus'),
              message: 'Пожалуйста, выберите действие или ручной статус',
            },
          ]}
        >
          <Select
            onChange={handleActionChange}
            disabled={!!form.getFieldValue('manualStatus')}
            allowClear
          >
            <Select.Option value="to1" disabled={isDisabled('to1Frequency')}>ТО 1</Select.Option>
            <Select.Option value="to2" disabled={isDisabled('to2Frequency')}>ТО 2</Select.Option>
            <Select.Option value="to3" disabled={isDisabled('to3Frequency')}>ТО 3</Select.Option>
            <Select.Option value="majorRepair" disabled={isDisabled('majorRepairFrequency')}>Кап ремонт</Select.Option>
            <Select.Option value="verification" disabled={isDisabled('verificationFrequency')}>Поверка</Select.Option>
            <Select.Option value="calibration" disabled={isDisabled('calibrationFrequency')}>Калибровка</Select.Option>
            <Select.Option value="testing" disabled={isDisabled('testingFrequency')}>Испытание</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Ручной статус"
          name="manualStatus"
          rules={[
            {
              required: !form.getFieldValue('action'),
              message: 'Пожалуйста, выберите ручной статус или действие',
            },
          ]}
        >
          <Select
            onChange={handleManualStatusChange}
            disabled={!!form.getFieldValue('action')}
            allowClear
            options={[
              { label: 'На ремонте', value: 'На ремонте' },
              { label: 'Ожидает зап части', value: 'Ожидает зап части' },
              { label: 'Неисправен', value: 'Неисправен' },
            ]}
          />
        </Form.Item>

        {/* Если user выбрал to3 => показываем поля for to3, to2, to1 */}
        {currentAction === 'to3' && (
          <>
            {/* ============= TO3 ============= */}
            <Form.Item
              name="commentTo3"
              label="Комментарий для ТО3"
              rules={[{ required: true, message: 'Комментарий для ТО3' }]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item label="Фотографии для ТО3">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => handleFileChange(e, setPhotoFilesTo3)}
              />
              {photoFilesTo3.length > 0 && (
                <p style={{ marginTop: 8 }}>Выбрано файлов: {photoFilesTo3.length}</p>
              )}
            </Form.Item>

            {/* ============= TO2 ============= */}
            <Form.Item
              name="commentTo2"
              label="Комментарий для ТО2 (опционально)"
            >
              <Input.TextArea placeholder="Если надо, можно заполнить" />
            </Form.Item>
            <Form.Item label="Фотографии для ТО2 (опционально)">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => handleFileChange(e, setPhotoFilesTo2)}
              />
              {photoFilesTo2.length > 0 && (
                <p style={{ marginTop: 8 }}>Выбрано файлов: {photoFilesTo2.length}</p>
              )}
            </Form.Item>

            {/* ============= TO1 ============= */}
            <Form.Item
              name="commentTo1"
              label="Комментарий для ТО1 (опционально)"
            >
              <Input.TextArea placeholder="Если надо, можно заполнить" />
            </Form.Item>
            <Form.Item label="Фотографии для ТО1 (опционально)">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => handleFileChange(e, setPhotoFilesTo1)}
              />
              {photoFilesTo1.length > 0 && (
                <p style={{ marginTop: 8 }}>Выбрано файлов: {photoFilesTo1.length}</p>
              )}
            </Form.Item>
          </>
        )}

        {/* Если user выбрал to2 => показываем поля for to2, to1 */}
        {currentAction === 'to2' && (
          <>
            {/* ============= TO2 ============= */}
            <Form.Item
              name="commentTo2"
              label="Комментарий для ТО2"
              rules={[{ required: true, message: 'Комментарий для ТО2' }]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item label="Фотографии для ТО2">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => handleFileChange(e, setPhotoFilesTo2)}
              />
              {photoFilesTo2.length > 0 && (
                <p style={{ marginTop: 8 }}>Выбрано файлов: {photoFilesTo2.length}</p>
              )}
            </Form.Item>

            {/* ============= TO1 ============= */}
            <Form.Item
              name="commentTo1"
              label="Комментарий для ТО1 (опционально)"
            >
              <Input.TextArea placeholder="Если надо, заполните" />
            </Form.Item>
            <Form.Item label="Фотографии для ТО1 (опционально)">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => handleFileChange(e, setPhotoFilesTo1)}
              />
              {photoFilesTo1.length > 0 && (
                <p style={{ marginTop: 8 }}>Выбрано файлов: {photoFilesTo1.length}</p>
              )}
            </Form.Item>
          </>
        )}

        {/* Если user выбрал to1, majorRepair, verification, ... или manualStatus => 
            показываем ОДНО поле "commentSingle" и "filesSingle" */}
        {(!currentAction || (
          currentAction !== 'to3' &&
          currentAction !== 'to2'
        )) && !form.getFieldValue('manualStatus') && (
          <>
            <Form.Item
              name="commentSingle"
              label="Комментарий"
              rules={[{ required: true, message: 'Комментарий обязателен' }]}
            >
              <Input.TextArea />
            </Form.Item>

            <Form.Item label="Фотографии (опционально)">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => handleFileChange(e, setPhotoFilesSingle)}
              />
              {photoFilesSingle.length > 0 && (
                <p style={{ marginTop: 8 }}>
                  Выбрано файлов: {photoFilesSingle.length}
                </p>
              )}
            </Form.Item>
          </>
        )}

        {/* Если выбрал manualStatus (и НЕТ action), 
            используем тоже "commentSingle" и "filesSingle" */}
        {form.getFieldValue('manualStatus') && !currentAction && (
          <>
            <Form.Item
              name="commentSingle"
              label="Комментарий"
              rules={[{ required: true, message: 'Комментарий обязателен' }]}
            >
              <Input.TextArea />
            </Form.Item>

            <Form.Item label="Фотографии (опционально)">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => handleFileChange(e, setPhotoFilesSingle)}
              />
              {photoFilesSingle.length > 0 && (
                <p style={{ marginTop: 8 }}>
                  Выбрано файлов: {photoFilesSingle.length}
                </p>
              )}
            </Form.Item>
          </>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Отправить
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ActionModal;
